import { Component, computed, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { Header } from '../header/header';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import permissionIndex from '../../../../core/guards/permissions-index';
import { AuthService } from '../../../../core/services/auth.service';
import { NetworkStatusService } from '../../../../core/services/network-status.service';
import { Breadcrumb } from '../breadcrumb/breadcrumb';
import { PageTitle } from '../page-title/page-title';
import { openLogoutConfirmationDialog } from '../dialog/confirm-dialog/logout-confirmation';

@Component({
  selector: 'app-page',
  templateUrl: './page.html',
  styleUrls: ['./page.sass'],
  imports: [
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    Header,
    Breadcrumb,
    PageTitle,
  ],
})
export class Page {
  navLinksList = permissionIndex;
  navLinks = computed(() => this.navLinksList ?? []);
  isSidebarExtended = false;
  authService = inject(AuthService);
  private dialog = inject(MatDialog);
  networkStatus = inject(NetworkStatusService);
  currentUser: any;
  isLoadingUser = true;

  constructor() {
    this.authService.populate().subscribe(() => {
      this.currentUser = this.authService.currentUser;
      this.isLoadingUser = false;
    });
  }

  confirmLogout(): void {
    openLogoutConfirmationDialog(this.dialog).subscribe((confirmed) => {
      if (confirmed) {
        this.authService.purgeAuth();
      }
    });
  }
}
